<script lang="ts">
	import { onMount } from 'svelte'
	import { Bell, Icon } from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
	import PaymentReminderDialog from '$lib/components/dialogs/PaymentReminder.svelte'
	import { isValidEmail } from '$lib/functions/formatters'
	import { account } from '$lib/stores/account/account'
	import { client } from '$lib/stores/client'
	import { ActiveDialog, dialog } from '$lib/stores/dialog/dialog'
	import { dimensions } from '$lib/stores/dimensions'
	import { calculated as invoice } from '$lib/stores/invoice/invoice'
	import { setDocument } from '$lib/stores/invoice/manager'
	import {
		AccPlanHasFeatureEnabled,
		Features_Name,
		InitAccSubPlanFeatures
	} from '$lib/stores/subscription_acc_plan_features/subscription_acc_plan_features'
	import type { CalculatedInvoice } from '$lib/types/client_types'

	import Switch from '../Common/switch.svelte'

	export let disabled = false

	let featurePayments_Reminders_enabled = false
	let document_data: CalculatedInvoice
	let editText = 'Edit reminders'

	const UPGRADE_MSG = 'Upgrade to turn on'

	let tooltipDueReminderAccess = ''
	$: {
		if (!featurePayments_Reminders_enabled) {
			tooltipDueReminderAccess = UPGRADE_MSG
			editText = UPGRADE_MSG
		} else {
			tooltipDueReminderAccess = ''
			editText = 'Edit reminders'
		}
	}

	$: reminderSwitchDown =
		tooltipDueReminder + tooltipDueReminderAccess !== '' && $dimensions.divRoot.width < 400
	$: reminderSwitchInMargin =
		tooltipDueReminder + tooltipDueReminderAccess !== '' &&
		$dimensions.divRoot.width > 400 &&
		$dimensions.divRoot.width < 450

	let disableOptDueReminder = false
	$: disableOptDueReminder = disabled ||
		!isValidEmail($client.email) || $client.email === '' || !featurePayments_Reminders_enabled

	let docDueReminderOn = true
	$: docDueReminderOn =
		isValidEmail($client.email) &&
		$client.email !== '' &&
		document_data.reminder_overdue &&
		featurePayments_Reminders_enabled

	$: remindersText =
		(docDueReminderOn ? 'Reminders are ' : 'Reminders are not ') + 'being sent for this invoice.'

	let tooltipDueReminder = ''
	$: {
		if ($client.email === '' && $account.stripe_subscription_status === 'active') {
			tooltipDueReminder = 'The client does not have an email!'
			// editText = 'The client does not have an email!'
			editText = ''
		} else if (!isValidEmail($client.email) && $account.stripe_subscription_status === 'active') {
			tooltipDueReminder = "The client's email is wrong!"
			// editText = "The client's email is wrong!"
			editText = ''
		} else {
			tooltipDueReminder = ''
			editText = 'Edit reminders'
		}
	}

	$: {
		document_data = $invoice
	}

	let dialogPaymentVisible = false

	function handleSwitchOn() {
		if (editText === UPGRADE_MSG) {
			// They want to subscribe or upgrade plan
			if (!$account.registered) {
				goto('/signup')
			} else {
				$dialog = ActiveDialog.Subscribe
			}
		}
		if (docDueReminderOn) dialogPaymentVisible = true
	}

	// let classSwitchOn = ''
	// $: classSwitchOn = docDueReminderOn ? 'cursor-pointer text-blue-600' : 'text-gray-600'

	onMount(async () => {
		await InitAccSubPlanFeatures()
		featurePayments_Reminders_enabled = AccPlanHasFeatureEnabled(Features_Name.Payments_Reminders)
	})

	const handleSwitch = (value: boolean) => {
		if (value) {
			setDocument({
				reminder_overdue: true,
				reminder_overdue_days: $account.reminder_invoice_overdue_days,
				reminder_overdue_days_1: $account.reminder_invoice_overdue_days_1,
				reminder_overdue_days_2: $account.reminder_invoice_overdue_days_2
			})
			dialogPaymentVisible = true
		} else {
			setDocument({
				reminder_overdue: false,
				reminder_overdue_days: 0,
				reminder_overdue_days_1: 0,
				reminder_overdue_days_2: 0
			})
		}
	}
</script>

<div class="remdinder flex flex-wrap items-center align-middle">
	<Icon src={Bell} size="16" class={docDueReminderOn ? 'text-emerald-500' : 'text-gray-500'}></Icon>
	<span class="reminder-text">{remindersText}&nbsp;</span>
	<div class={reminderSwitchDown ? 'w-full' : 'w-auto'}>
		<Switch
			data-test-id="reminder_invoice_overdue"
			data-tooltip={tooltipDueReminder + tooltipDueReminderAccess}
			style="--tooltip-width: 180px; {reminderSwitchDown
				? '--tooltip-left: 90px;'
				: reminderSwitchInMargin
					? '--tooltip-left: -30px;'
					: ''}"
			size="xxs"
			leftToRight={true}
			bind:checked={docDueReminderOn}
			bind:disabled={disableOptDueReminder}
			on:input={(e) => {
				handleSwitch(e.detail.value)
			}}
		/>
		{#if docDueReminderOn}
			<a
				class="reminder-link"
				href={''}
				data-test-id="edit_reminders"
				on:click|preventDefault|stopPropagation={handleSwitchOn}
			>
				{editText}</a
			>
		{/if}
	</div>
	{#if dialogPaymentVisible && !disabled}
		<div class="relative">
			<PaymentReminderDialog on:close={() => (dialogPaymentVisible = false)} />
		</div>
	{/if}
</div>



<style lang="postcss">
	.remdinder {
		padding: 8px;
		gap: 4px;
	}

	.reminder-text {
		color: #262626;
		font-size: 14px;
		font-weight: 400;
	}
	.reminder-link {
		font-size: 14px;
		font-weight: 400;
		@apply underline text-blue-500;
	}
	.reminder-link:hover {
		@apply text-blue-700;
	}
</style>
